export default {
    optionFilterGroups: ['Hair Color', 'Eye Color', 'Body Type', 'Drink', 'Smoke', 'Relation Status', 'Education Level', 'Language','Interest'],
    async init() {
        await Promise.all([
            axios.get("/countries").then(response => {
                this.states.countries = response.data.data;
            }),
            axios.get("/search-options").then(response => {
                this.states.options = response.data.data;
            }),
            axios.get("/search-filters").then(response => {
                _.forEach({...this.states.filters, ...response.data.data}, (value, key) => this.states.filters[key] = value)
            }),
        ])
        await this.search()
    },
    async search() {
        this.states.page = 1
        this.states.isLoading = true
        this.states.advance = false

        axios
            .post("/en/search-people", {
                ...this.states.filters,
                ...{page: this.states.page}
            })
            .then(response => {
                this.states.people = response.data.data;
            })
            .finally(() => this.states.isLoading = false)
    },
    async infiniteHandler($state) {
        axios
            .post("/en/search-people", {
                ...this.states.filters,
                ...{page: this.states.page + 1}
            })
            .then(response => {
                if (response.data.data.length) {
                    this.states.page = response.data.meta.current_page + 1;
                    this.states.people.push(...response.data.data);
                    $state.loaded();
                } else {
                    $state.complete();
                }
            });
    },
    criteriaFilterCount() {
        let count = 0
        let criteria = this.states.filters.criteria
        this.optionFilterGroups.forEach(group => criteria[this.groupKey(group)].length !== 0 && count++)
        criteria.weight.from !== null && count++
        criteria.weight.to !== null && count++
        criteria.height.from !== null && count++
        criteria.weight.to !== null && count++
        criteria.haveKids !== null && count++
        return count
    },
    resetCriteria() {
        this.optionFilterGroups.forEach(group => this.states.filters.criteria[this.groupKey(group)] = [])
        this.states.filters.criteria.weight.from = null
        this.states.filters.criteria.weight.to = null
        this.states.filters.criteria.height.from = null
        this.states.filters.criteria.height.to = null
        this.states.filters.criteria.haveKids = null
    },
    toggleAdvance() {
        this.states.advance = !this.states.advance
    },
    groupKey(group) {
        console.log(_.camelCase(group))
        return _.camelCase(group)
    },
    options(key) {
        key = this.groupKey(key)
        let results = _.filter(this.states.options, options => options.key === key);
        return results.length === 0 ? [] : results[0].records
    },
    criteriaIsActive(group){
        group = this.groupKey(group)
        let criteria = this.states.filters.criteria;
        if(group === 'weight'){
            return criteria.weight.from !== null || criteria.weight.to !== null
        }
        if(group === 'height'){
            return criteria.height.from !== null || criteria.height.to !== null
        }
        if(group === 'haveChildren'){
            return criteria.haveKids !== null
        }
        return criteria[group].length !== 0
    },
    optionIsActive(group, option) {
        group = this.groupKey(group)
        return this.states.filters.criteria[group].includes(option.id)
    },
    toggleOption(group, option) {
        group = this.groupKey(group)
        this.states.filters.criteria[group] = this.optionIsActive(group, option) ?
            this.states.filters.criteria[group].filter(item => item !== option.id) :
            [...this.states.filters.criteria[group], option.id]
    },
    states: Vue.observable({
        advance: false,
        advance_tab : 'height',
        isLoading: true,
        page: 1,
        people: [],
        ages: [18, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 80],
        countries: [],
        options: {},
        filters: {
            username : '',
            email : '',
            name : '',
            genders: {
                iAm: "man",
                lookingFor: "woman"
            },
            startAge: 18,
            endAge: 18,
            favoriteCountries: [],
            criteria: {
                hairColor: [],
                eyeColor: [],
                bodyType: [],
                drink: [],
                smoke: [],
                relationStatus: [],
                educationLevel: [],
                language: [],
                interest: [],
                haveKids: null,
                height: {
                    from: null,
                    to: null
                },
                weight: {
                    from: null,
                    to: null
                }
            }
        }
    })
}
